import { useTranslation } from 'react-i18next';

import PatientNameColumn from './patient-name';
import ProviderColumn from './provider';
import ClinicColumn from './clinic';
import ActiveDateColumn from './active-date';
import NumberColumn from './number';
import PatientGuidColumn from './patient-guid';

import type { INewPatientsData } from 'infrastructure/interfaces/';
import type { TableProps } from 'antd';

export const newPatientsReportTableColumns = (
  currentPage: number,
): TableProps<INewPatientsData>['columns'] => {
  const { t } = useTranslation();

  return [
    {
      title: '№',
      key: 'guid',
      width: '50px',
      align: 'center',
      render: (_, record, idx) => (
        <NumberColumn currentPage={currentPage} idx={idx} />
      ),
    },
    {
      title: t('labels.patientID'),
      key: 'guid',
      render: (_, record) => <PatientGuidColumn guid={record.guid} />,
    },
    {
      title: t('labels.patientName'),
      key: 'patientFullName',
      render: (_, record) => <PatientNameColumn data={record} />,
    },
    {
      title: t('labels.provider'),
      key: 'provider',
      render: (_, record) => <ProviderColumn data={record} />,
    },
    {
      title: t('labels.clinic'),
      key: 'clinic',
      render: (_, record) => <ClinicColumn data={record} />,
    },
    {
      title: t('labels.activeDate'),
      key: 'activeDate',
      render: (_, record) => <ActiveDateColumn data={record} />,
    },
  ];
};
